import { Dimension2D, Rectangle } from '../types/geo.types';
import { GLFXCanvas, GLFXFilterConfig } from './filter.contants';

declare var fx;
declare var WebPEncoder;

export class CCanvas {
    public static drawImage(canvas: HTMLCanvasElement, image: HTMLImageElement) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + canvas.id);
        }
        ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight);
    }

    public static resize(canvas: HTMLCanvasElement, targetSize: Dimension2D) {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = targetSize ? targetSize.width : canvas.width;
        tempCanvas.height = targetSize ? targetSize.height : canvas.height;
        const ctx = tempCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + tempCanvas.id);
        }

        const srcY = targetSize['top'] || 0;
        const srcX = targetSize['left'] || 0;

        ctx.drawImage(
            canvas,
            srcX, srcY, canvas.width, canvas.height,
            0, 0, tempCanvas.width, tempCanvas.height,
        );

        CCanvas.copyCanvas(tempCanvas, canvas);
        tempCanvas.remove();
    }

    public static crop(canvas: HTMLCanvasElement, rect: Rectangle) {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = rect.width;
        tempCanvas.height = rect.height;
        const ctx = tempCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + tempCanvas.id);
        }

        const srcY = rect.top;
        const srcX = rect.left;

        ctx.drawImage(
            canvas,
            srcX, srcY, tempCanvas.width, tempCanvas.height,
            0, 0, tempCanvas.width, tempCanvas.height,
        );

        CCanvas.copyCanvas(tempCanvas, canvas);
        tempCanvas.remove();
    }

    public static copyCanvas(sourceCanvas: HTMLCanvasElement, targetCanvas: HTMLCanvasElement, targetSize?: Dimension2D) {
        targetCanvas.width = targetSize ? targetSize.width : sourceCanvas.width;
        targetCanvas.height = targetSize ? targetSize.height : sourceCanvas.height;
        const ctx = targetCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + targetCanvas.id);
        }
        ctx.drawImage(
            sourceCanvas,
            0, 0, sourceCanvas.width, sourceCanvas.height,
            0, 0, targetCanvas.width, targetCanvas.height,
        );
    }

    public static flip2(canvas: HTMLCanvasElement, scaleX: number, scaleY: number) {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;
        const ctx = tempCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + tempCanvas.id);
        }
        console.time('todataurl');
        const width = tempCanvas.width;
        const height = tempCanvas.height;

        ctx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);

        const posX = scaleX === -1 ? width * -1 : 0; // Set x position to -100% if flip horizontal
        const posY = scaleY === -1 ? height * -1 : 0; // Set y position to -100% if flip vertical

        ctx.save(); // Save the current state
        ctx.scale(scaleX, scaleY); // Set scale to flip the image
        ctx.drawImage(canvas, posX, posY, width, height); // draw the image
        ctx.restore(); // Restore the last saved state
        console.timeEnd('todataurl');
        CCanvas.copyCanvas(tempCanvas, canvas);
        // tempCanvas.remove();
    }

    public static flip(sourceCanvas: HTMLCanvasElement, targetCanvas: HTMLCanvasElement, scaleX: number, scaleY: number) {
        targetCanvas.width = sourceCanvas.width;
        targetCanvas.height = sourceCanvas.height;
        const ctx = targetCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + targetCanvas.id);
        }
        console.time('todataurl');
        const width = targetCanvas.width;
        const height = targetCanvas.height;

        ctx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);

        const posX = scaleX === -1 ? width * -1 : 0; // Set x position to -100% if flip horizontal
        const posY = scaleY === -1 ? height * -1 : 0; // Set y position to -100% if flip vertical

        ctx.save(); // Save the current state
        ctx.scale(scaleX, scaleY); // Set scale to flip the image
        ctx.drawImage(sourceCanvas, posX, posY, width, height); // draw the image
        ctx.restore(); // Restore the last saved state
        console.timeEnd('todataurl');
    }

    public static rotate2(canvas: HTMLCanvasElement, angle: number) {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;

        if (angle == 90 || angle == 270) {
            tempCanvas.width = canvas.height;
            tempCanvas.height = canvas.width;
        } else {
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
        }

        const ctx = tempCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + tempCanvas.id);
        }
        ctx.save(); // Save the current state
        ctx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
        if (angle == 90 || angle == 270) {
            ctx.translate(canvas.height / 2, canvas.width / 2);
        } else {
            ctx.translate(canvas.width / 2, canvas.height / 2);
        }
        ctx.rotate(angle * Math.PI / 180);
        ctx.drawImage(canvas, -1 * canvas.width / 2, -1 * canvas.height / 2);
        ctx.restore(); // Restore the last saved state
        CCanvas.copyCanvas(tempCanvas, canvas);
        tempCanvas.remove();
    }

    public static rotate(sourceCanvas: HTMLCanvasElement, targetCanvas: HTMLCanvasElement, angle: number) {
        const ctx = targetCanvas.getContext('2d');
        if (!ctx) {
            throw Error('2D CTX was null: CanvasID: ' + targetCanvas.id);
        }

        if (angle == 90 || angle == 270) {
            targetCanvas.width = sourceCanvas.height;
            targetCanvas.height = sourceCanvas.width;
        } else {
            targetCanvas.width = sourceCanvas.width;
            targetCanvas.height = sourceCanvas.height;
        }

        ctx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
        ctx.save(); // Save the current state
        if (angle == 90 || angle == 270) {
            ctx.translate(sourceCanvas.height / 2, sourceCanvas.width / 2);
        } else {
            ctx.translate(sourceCanvas.width / 2, sourceCanvas.height / 2);
        }
        ctx.rotate(angle * Math.PI / 180);
        ctx.drawImage(sourceCanvas, -1 * sourceCanvas.width / 2, -1 * sourceCanvas.height / 2);
        ctx.restore(); // Restore the last saved state
    }

    public static applyFilter(fxCanvas: GLFXCanvas, config: GLFXFilterConfig, targetCanvas: HTMLCanvasElement): void {
        console.warn('Disabled');
        return;
        // const canvas = fx.canvas(); // fxCanvas;
        // canvas.width = targetCanvas.width;
        // canvas.height = targetCanvas.height;
        // CCanvas.resizeWebGLContext(fxCanvas.getContext('webgl'));
        // const texture = canvas.texture(targetCanvas);
        // let c = canvas.draw(texture);
        // if (config.blur > 0) {
        //     c = c.triangleBlur(config.blur);
        // } else {
        //     c = c.unsharpMask(3, -1 * config.blur / 20);
        // }

        // if (config.brightness || config.contrast) {
        //     c = c.brightnessContrast(config.brightness / 100, config.contrast / 100);
        // }
        // if (config.saturation) {
        //     c = c.saturation(config.saturation);
        // }
        // if (config.vignette) {
        //     c = c.vignette(.1, config.vignette / 100);
        // }
        // if (config.xpro) {
        //     const cur = GLFXFilterValueMap.curves['' + config.xpro];
        //     c = c.curves(cur.red, cur.green, cur.blue);
        // }

        // if (config.tint) {
        //     const l = GLFXFilterValueMap.tint['' + config.tint];
        //     c.colorize(l.color.r, l.color.g, l.color.b, l.amount / 100);
        // }

        // c.update();
        // CCanvas.copyCanvas(c, targetCanvas);
    }

    public static resizeWebGLContext(webGLContext: any) {
        const realToCSSPixels = window.devicePixelRatio;

        // Lookup the size the browser is displaying the canvas in CSS pixels
        // and compute a size needed to make our drawingbuffer match it in
        // device pixels.
        const displayWidth = Math.floor(webGLContext.canvas.clientWidth * realToCSSPixels);
        const displayHeight = Math.floor(webGLContext.canvas.clientHeight * realToCSSPixels);

        // Check if the canvas is not the same size.
        if (webGLContext.canvas.width !== displayWidth ||
            webGLContext.canvas.height !== displayHeight) {

            // Make the canvas the same size
            webGLContext.canvas.width = displayWidth;
            webGLContext.canvas.height = displayHeight;
        }
    }

    public static async canvasToWebPBlob(sourceCanvas: HTMLCanvasElement, qualityVal) {
        // 24bit data (alpha coming soon)
        const sCTX = sourceCanvas.getContext('2d');
        const input = sCTX.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
        const w = input.width, h = input.height;
        const inputData = input.data;
        const out = { output: '' };
        const start = new Date();

        // CODE START
        const encoder = new WebPEncoder();

        // Config, you can set all arguments or what you need, nothing no objeect
        const config: any = new Object();
        config.target_size = 0;			// if non-zero, set the desired target size in bytes. Takes precedence over the 'compression' parameter.
        config.target_PSNR = 0.;		// if non-zero, specifies the minimal distortion to	try to achieve. Takes precedence over target_size.
        config.method = 0;				// quality/speed trade-off (0=fast, 6=slower-better)
        config.sns_strength = 50;		// Spatial Noise Shaping. 0=off, 100=maximum.
        config.filter_strength = 20;  	// range: [0 = off .. 100 = strongest]
        config.filter_sharpness = 0;	// range: [0 = off .. 7 = least sharp]
        config.filter_type = 1;			// filtering type: 0 = simple, 1 = strong (only used if filter_strength > 0 or autofilter > 0)
        config.partitions = 0;			// log2(number of token partitions) in [0..3] Default is set to 0 for easier progressive decoding.
        config.segments = 4;			// maximum number of segments to use, in [1..4]
        config.pass = 1;				// number of entropy-analysis passes (in [1..10]).
        config.show_compressed = 0;		// if true, export the compressed picture back. In-loop filtering is not applied.
        config.preprocessing = 0;		// preprocessing filter (0=none, 1=segment-smooth)
        config.autofilter = 0;			// Auto adjust filter's strength [0 = off, 1 = on]
        //   --- description from libwebp-C-Source Code ---
        config.extra_info_type = 0;		// print extra_info
        config.preset = 0; 				// 0: default, 1: picture, 2: photo, 3: drawing, 4: icon 5: text

        // set Config; default config -> WebPConfig( null )
        encoder.WebPEncodeConfig(config); // when you set the config you must it do for every WebPEncode... new

        // start encoding
        console.time('time Encoder');
        const size = encoder.WebPEncodeRGBA(inputData, w, h, w * 4, qualityVal, out); // w*4 desc: w = width, 3:RGB/BGR, 4:RGBA/BGRA
        console.timeEnd('time Encoder');
        // CODE END

        console.time('time btoa');
        const base64URI = btoa(out.output);
        console.timeEnd('time btoa');
        const src = 'data:image/webp;base64,' + base64URI;
        console.time('time dataURItoBlob');
        const blob = CCanvas.dataURItoBlob(src);
        console.timeEnd('time dataURItoBlob');
        return blob;
    }

    public static dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        const byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        const ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        const ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        const blob = new Blob([ab], { type: mimeString });
        return blob;

    }
}
